/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

// @ is an alias to /src
import HelloWorld from '@/components/HelloWorld.vue';

export default {
    name: 'Home',
    data() {
        return {
            'check': this.Constants.STATUS_CONFIRMED
        }
    },
    components: {
        HelloWorld
    }
}
